module.exports = __webpack_public_path__ + "img/code2.305d0ca4.png";